angular.module('env.data.repos.orderItems', [])

    .service('orderItemsRepository', function ($q, rest) {
        var _this = this;
        var orderItemType = "OrderItemModel";
        var documentType = "DocumentModel";
        var commentType = "CommentModel";
        var workflowAuditRecordType = "WorkflowAuditRecordModel";
        var categoryTypeModel = "CategoryTypeModel";
        var orderItemDef = rest.getDefinition(orderItemType);

        /**
         * Get order items by step code
         * @param {string} stepCode step code
         * @returns {!Promise.<RepresentationModel[]>} promise of order items collection
         */
        _this.getOrderItemsByStep = function (stepCode) {
            return rest
                .map(orderItemDef)
                .willReturn(orderItemType)
                .get({params: {step: stepCode}});
        };

        /**
         * Get orderItem by id
         * @param {string|number} id id of the OrderItem
         * @returns {!Promise.<RepresentationModel>} promise of order
         */
        _this.getOrderItem = function (id) {
            return rest
                .map(orderItemDef)
                .map(id)
                .willReturn(orderItemType, id)
                .get();
        };

        /**
         * Get order items by orders
         * @param {string[]} orders array of order ids
         * @returns {!Promise.<RepresentationModel[]>} promise of order items collection
         */
        _this.getOrderItemsByOrders = function (orders) {
            return rest
                .map(orderItemDef)
                .willReturn(orderItemType)
                .get({params: {order: orders.join()}});
        };

        /**
         * Save order item
         * @param {RepresentationModel} orderItem Order Item Model
         * @returns {!Promise.<RepresentationModel>} promise of saved orderItem
         */
        _this.saveOrderItem = function (orderItem) {
            return rest
                .map(orderItemDef)
                .save(orderItem);
        };

        //region Search

        var searchQueryCache = [];
        /**
         * Search order items
         * @param {{where: string, orderBy: string, pageNumber: number, rowsPerPage: number}} query
         * @returns {!Promise} promise of search results
         */
        _this.search = function (query) {
            var executing = _.find(searchQueryCache, function (q) {
                return _.isEqual(q.query, query);
            });
            if (executing) {
                return executing.promise
                    .then(function (resp) {
                        return _.clone(resp); // clone to prevent modification of response content
                    });
            }

            var p = rest
                .map(orderItemDef)
                .map("search")
                .willReturn(orderItemType)
                .search(query)
                .then(function (resp) {
                    searchQueryCache = _.reject(searchQueryCache, function (q) {
                        return _.isEqual(q.query, query);
                    });
                    return _.clone(resp);
                }, function (err) {
                    searchQueryCache = _.reject(searchQueryCache, function (q) {
                        return _.isEqual(q.query, query);
                    });
                    return $q.reject(err);
                });

            searchQueryCache.push({
                query: _.clone(query),
                promise: $q.when(p)
            });

            return $q.when(p);
        };

        var countQueryCache = [];
        /**
         * Count order items corresponding  to the specified OMQL query (ignoring orderBy and rowsPerPage)
         * @param {{where: string}} query
         * @returns {!Promise} promise of search count results
         */
        _this.searchCount = function (query) {
            var executing = _.find(countQueryCache, function (q) {
                return _.isEqual(q.query, query);
            });
            if (executing) {
                return executing.promise
                    .then(function (resp) {
                        return _.clone(resp); // clone to prevent modification of response content
                    });
            }

            var p = rest
                .map(orderItemDef)
                .map("searchCount")
                .post(query)
                .then(function (resp) {
                    countQueryCache = _.reject(countQueryCache, function (q) {
                        return _.isEqual(q.query, query);
                    });
                    return _.clone(resp);
                }, function (err) {
                    countQueryCache = _.reject(countQueryCache, function (q) {
                        return _.isEqual(q.query, query);
                    });
                    return $q.reject(err);
                });

            countQueryCache.push({
                query: _.clone(query),
                promise: $q.when(p)
            });

            return $q.when(p);
        };

        //endregion

        //region Documents

        /**
         * Get Documents of the Order Item
         * @param {RepresentationModel|string} orderItem Order Item Model or Order Item id
         * @returns {!Promise.<RepresentationModel[]>} promise of Documents collection
         */
        _this.getDocuments = function (orderItem) {
            return rest
                .map(orderItemDef)
                .map(orderItem)
                .map("documents")
                .willReturn(documentType)
                .get();
        };

        //endregion

        //region Comments of Order item

        /**
         * Get Comments of the Order Item
         * @param {RepresentationModel|string} orderItem Order Item Model or Order Item Id
         * @returns {!Promise.<RepresentationModel[]>} promise of Comments collection
         */
        _this.getComments = function (orderItem) {
            return rest
                .map(orderItemDef)
                .map(orderItem)
                .map("comments")
                .willReturn(commentType)
                .get();
        };

        /**
         * Get Workflow audit of the Order Item
         * @param {RepresentationModel|string} orderItem Order Item Model or Order Item Id
         * @returns {!Promise.<RepresentationModel[]>} promise of Workflow audit records collection
         */
        _this.getWorkflowAudit = function(orderItem) {
            return rest
                .map(orderItemDef)
                .map(orderItem)
                .map("workflow-audit")
                .willReturn(workflowAuditRecordType)
                .get();
        }

        /**
         * Save new comment of the Order Item
         * @param {RepresentationModel|string} orderItem Order Item Model or Order Item Id
         * @param {RepresentationModel} comment Comment model
         * @returns {!Promise.<RepresentationModel>} promise of Comment save
         */
        _this.saveComment = function (orderItem, comment) {
            return rest
                .map(orderItemDef)
                .map(orderItem)
                .map("comments")
                .save(comment);
        };

        _this.downloadDocument = function (documentId) {
            return rest
                .map("documents")
                .map(documentId)
                .map("download")
                .get();
        };

        //endregion

        //region Categories

        /**
         * Get order items by category id collection
         * @param {!string[]|!number[]} categoryIds array of category ids
         * @returns {!Promise.<RepresentationModel[]>} promise of order items collection
         */
        _this.getOrderItemsByCategories = function (categoryIds) {
            return rest
                .map(orderItemDef)
                .willReturn(orderItemType)
                .get({params: {category: categoryIds}});
        };

        /**
         * Get order items by id collection
         * @param {!string[]|!number[]} itemsIds array of items ids
         * @returns {!Promise.<RepresentationModel[]>} promise of order items collection
         */
        _this.getOrderItemsByIds = function(ids) {
            return rest
                .map(orderItemDef)
                .willReturn(orderItemType)
                .get({params: {id: ids}});
        }

        /**
         * Get Categories for OrderItem
         * @param {string|number} id id of OrderItem
         * @returns {!Promise.<RepresentationModel[]>} promise of Category collection
         */
        _this.getCategoriesForOrderItem = function (id) {
            return rest
                .map(orderItemDef)
                .map(id)
                .map("categories")
                .willReturn(categoryTypeModel)
                .get();
        };

        /**
         * Link Categories to OrderItem
         * @param {!string|!number} orderItemId id of OrderItem
         * @param {!string[]|!number[]} categoryIds collection of Category ids
         * @returns {!Promise} promise of operation result
         */
        _this.linkCategoriesToOrderItem = function (orderItemId, categoryIds) {
            return rest
                .map(orderItemDef)
                .map(orderItemId)
                .map("linkcategories")
                .post({categoryIds: categoryIds});
        };

        /**
         * Unlink Categories From OrderItem
         * @param {!string|!number} orderItemId id of OrderItem
         * @param {!string[]|!number[]} categoryIds collection of Category ids
         * @returns {!Promise} promise of operation result
         */
        _this.unlinkCategoriesFromOrderItem = function (orderItemId, categoryIds) {
            return rest
                .map(orderItemDef)
                .map(orderItemId)
                .map("unlinkcategories")
                .post({categoryIds: categoryIds});
        };

        //endregion

        //region Custom fields

        var _cfDefs;
        /**
         * Get all custom fields for OrderItem
         * @returns {!Promise.<Object[]>} promise of Custom Field Definition list
         */
        _this.getCustomFieldDefinitions = function () {
            if (_cfDefs) {
                return $q.when(_.clone(_cfDefs));
            }
            return rest
                .map(orderItemDef)
                .map("customfielddefinitions")
                .get()
                .then(function (definitions) {
                    _cfDefs = definitions;
                    return _.clone(_cfDefs);
                });
        };

        //endregion

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var orderItemUrl = rest.getDefinition("OrderItemModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(orderItemUrl, baserUrl + "/" + orderItemUrl));
        requestCoupler.addCoupler(requestCouplerUtils.createCustomFieldsCollectionCoupler(orderItemUrl, "customfields", baserUrl + "/" + orderItemUrl + "/customfields"));
        requestCoupler.addCoupler(requestCouplerUtils.createDocumentsCollectionCoupler(orderItemUrl, "documents", baserUrl + "/" + orderItemUrl + "/documents"));
        requestCoupler.addCoupler(requestCouplerUtils.createWorkflowAuditCollectionCoupler(orderItemUrl, "workflow-audit", baserUrl + "/" + orderItemUrl + "/workflow-audit"));
    })

;
